import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { useGalleryImagesForPreview } from "@/api/hooks/useGalleryImagesForPreview";

const GalleryPlaceholder = ({ className }: { className?: string }) => (
  <div
    className={`bg-[#2C2C2E] flex items-center justify-center rounded-3xl max-md:rounded ${className}`}
    aria-hidden
  >
    <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border-2 border-[#8E8E93] border-dashed opacity-50" />
  </div>
);

const ArtistEconomyGallery = () => {
  const { slots } = useGalleryImagesForPreview("economy");

  return (
    <>
      <div className="grid grid-cols-2 justify-items-center place-content-center gap-20 max-md:gap-4 py-20 max-md:py-10 w-screen">
        {slots.map((slot, index) => (
          <div
            key={slot.type === "image" ? slot.id : `ph-${slot.index}`}
            className="relative w-full max-w-[700px] h-[500px] max-md:max-w-[180px] max-md:h-[210px] rounded-3xl max-md:rounded pointer-events-none overflow-hidden"
          >
            {slot.type === "image" ? (
              <OptimizedImage
                src={slot.url}
                alt={`Gallery ${index + 1}`}
                fill={true}
                className="object-cover object-top rounded-3xl max-md:rounded"
              />
            ) : (
              <GalleryPlaceholder className="w-full h-full" />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ArtistEconomyGallery;
